import { Card } from './Card'
import { separateNumber } from 'utils/utils'
import FloatingText from 'components/commons/FloatingText'

export const LeaveUtilization = ({ data, isLoading, isBottom, scrollRef, handleScroll, filter, onSubmitFilter }) => {
    return (
        <Card
            isLoading={isLoading}
            title='Leave Utilization'
            name='leave-utilization'
            filterTitle='Filter Leave Utilization'
            initFilter={filter}
            onSubmitFilter={onSubmitFilter}
        >
            <div className='relative'>
                <div
                    ref={scrollRef}
                    onScroll={handleScroll}
                    className='grid grid-cols-2 gap-5 p-3 h-72 overflow-auto pr-2'
                >
                    {data?.map((item, index) => (
                        <div key={index} className='flex flex-col space-y-2 w-full'>
                            {/* label */}
                            <div className='flex justify-between mb-1'>
                                <FloatingText className='flex-1 uppercase font-semibold' enableCopy>
                                    {item?.name}
                                </FloatingText>
                                <span className='font-medium text-neutral-70 text-end'>
                                    {separateNumber(item?.used_quota) || 0}{' '}
                                    <span className='text-xs text-neutral-60'>days</span>
                                </span>
                            </div>

                            {/* background */}
                            <div className='flex items-center gap-1'>
                                <div className='flex-1 h-3 bg-neutral-30 rounded-full overflow-hidden'>
                                    {/* progress */}
                                    <div
                                        className='h-full rounded-full'
                                        style={{ width: `${item?.percentage}%`, backgroundColor: item?.color }}
                                    />
                                </div>
                                <div className='w-8 text-end font-semibold' style={{ color: item?.color }}>
                                    {item?.percentage}%
                                </div>
                            </div>

                            <div className='text-neutral-60 text-sm'>{item?.average} days / emp avg.</div>
                        </div>
                    ))}
                </div>

                {/* Fade bottom */}
                {!isBottom && (
                    <div className='pointer-events-none absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-white to-transparent' />
                )}
            </div>
        </Card>
    )
}
